// extracted by mini-css-extract-plugin
export default {"id":"StudentChargeSelect_id__XLgbm","date":"StudentChargeSelect_date__QwYn8","period":"StudentChargeSelect_period__M0SI7"};